/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "workflowactionautoviewer",
	listeners: listeners,

	tryView: tryView,

	_actions: [],
	_isActive: null,
});

function listeners(){
	return {
		"workflowactionpending:updated": handle_actions_updated,
		"activeworkflowaction:updated": handle_active_updated,
	};
}

function handle_actions_updated(actions) {
	this._actions = actions.filter(function(action){
		var actionLabel = action.action;
		var actionSchema = action.ongoingWorkflow.workflow.actions[actionLabel];
		return actionSchema.priority !== -1;
	});

	this.tryView();
}

function handle_active_updated(active) {
	this._isActive = active;
}

function tryView() {
	// If there are no actions, don't try viewing
	if(!this._actions.length)
		return;

	// Load the most recent action
	var lastAction = this._actions[this._actions.length - 1];

	// Don't try to view the action if it's the one currently being viewed
	if(this._isActive && (this._isActive._id === lastAction._id))
		return;

	this.emit("activeworkflowaction:trigger:view", {
		action: lastAction._id
	});
}
